import * as React from "react";
import { SectionHeader } from "../SharedComponents";
import { CheckboxGroup } from "../../../../../../Shared/CheckboxGroup/CheckboxGroup";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { WizardLinter, EWizardLinterStatus } from "../../../../../../Shared/Process/Process/WizardLinter";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { DisinvestmentStrategyTypeStringMap, NBSteppers } from "../../Resource/Contents";
import { AdviserContextStoreStatic, CustomerContextStoreStatic, ProductWrapperStore } from "../../Stores/Variable";
import { NewBusinessAction } from "../../Actions/NewBusinessAction";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { ProductWrapper } from "../../../../../../../Wrap/Models/Domains/Account/ProductWrapper";
import { PartLoading } from "../../../../../../../react-core/Html/PartLoading";
import { ISASection } from "./ISASection/ISASection";
import { PPSection } from "./PPSection/PPSection";
import { NewClientAlertMessage } from "../../../Common/WrapperSelection/NewClientAlertMessage";
import { SubAccountTypeHelper } from "../../../Common/Helpers/SubAccountTypeHelper";
import { SIPPSection } from "./SIPPSection/SIPPSection";
import { ClientAccount } from "../../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { ProductDetailsStore } from "../../../../../Stroes/Variable";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { ClientAcountHelper } from "../../Resource/ClientAccountHelper";
import { InvestorType } from "../../../../../../../Wrap/Constants/Enums/Domain/InvestorType";
import { HierarchyLevelName } from "../../../../../../../Wrap/Constants/Enums/HierarchyLevelName";
import { QuoteAndApplyBaseModel } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/QuoteAndApplyBaseModel";
import { SubAccountActionIndicators } from "../../../../../../../Wrap/Models/Models/Shared/SubAccountActionIndicators";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { PersonalPortfolioTypesMap } from "../../../NewQuoteWizard/Resource/Content";
import { ApplyModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/ApplyModel";
import { Action } from "../../../../../Actions/Action";
import { AccountRole } from "../../../../../../../Wrap/Models/Domains/Account/AccountRole";
import { ServicePropositionSelection } from "../../../Common/ServicePropositionSelection";
import { FullClientDetailModel } from "../../../../../../../Wrap/Models/Models/Customer/FullClientDetailModel";
import { InvestorType as InvestorTypeAccount } from "../../../../../../../Wrap/Models/Domains/Account/SlAccounts/InvestorType";
import { PortfolioDashboardAction } from "../../../PortfolioDashboard/Action/PortfolioDashboardAction";
import { CommonHelper } from "../../../../../../../react-core/Helpers/CommonHelper";
import { PortfolioDashboardStore } from "../../../PortfolioDashboard/Store/Variable";
import { ClientDetails } from "../../../../../../../Wrap/Models/Models/Processes/Quote/ClientDetails";
import {
    getWarningMessage,
    isCreatingNewAccount,
    isSelectedAndExisted,
    disableCashAccount,
} from "./WrapperSelctionHelper";
import { AdviceSection } from "./AdviceSection";
import { JointAccountHolder } from "./JointAccountHolder";
import { Customer } from "../../../../../../../Wrap/Models/Domains/Users/Customer";
import { RestrictionAction } from "../../../Common/Restrictions/RestrictionAction";
import { ProcessType } from "../../../../../../../Wrap/Constants/Enums/Client/DashboardFilter/ProcessType";
import { processTypeEnum } from "../../../Common/Resource/Contents";
import { RestrictionHelper } from "../../../../../../Shared/Common/RestrictionHelper";
import { RestrictionStore } from "../../../Common/Restrictions/Variable";
import { DisinvestmentStrategyType } from "../../../../../../../Wrap/Constants/Enums/Client/DisinvestmentStrategyType";
import { DisinvestmentStrategySection } from "./DisinvestmentStrategySection";
import { AccountName } from "../../../Common/WrapperSelection/AccountName";
import { ProductOverviewChargeAction } from "../../../PortfolioDashboard/Components/ProductOverview/Action/ProductOverviewChargeAction";
import { AccountDisinvestmentStrategy } from "../../../../../../../Wrap/Models/Domains/Account/AccountDisinvestmentStrategy";
import { ServiceProposition } from "../../../../../../../Wrap/Constants/Enums/ServiceProposition";
import { CompanyWizardAction } from "../../../../../../Admin/Company/CompanyWizard/Actions/CompanyWizardAction";
import { Money } from "../../../../../../../Wrap/Core/DataTypes/Money";
import { CurrencyCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { DisinvestmentStrategyTypeAction } from "../../../../Workflow/Action/DisinvestmentStrategyTypeSearchAction";
import { DisinvestmentStrategyTypeModel } from "../../../../../../../Wrap/Models/Domains/Instructions/DisinvestmentStrategyTypeModel";
import { FsaPermission } from "../../../../../../../Wrap/Models/Models/Company/FsaPermission";
interface IWrapperSelectionProps extends IProcessComponentProps {
    HasExistingSIPP?: boolean;
    ClientAccount?: ClientAccount;
    data: ApplyModel;
}
interface IWrapperSelectionState {
    ProductWrappers: ProductWrapper[];
    isLoading: boolean;
    isBusy: boolean;
    errorMessages: string[];
    accountRole: Array<AccountRole>;
    selectedClientInfo: FullClientDetailModel;
    allAccounts: ClientAccount[];
    urlCustomer: ClientDetails;
    accountDisinvestmentStrategy: DisinvestmentStrategyType;
    companyDisinvestmentStrategy: DisinvestmentStrategyType;
    fsaPermission: FsaPermission[];
}
export class WrapperSelection extends ProcessComponent<IWrapperSelectionProps, IWrapperSelectionState> {
    constructor(props: any) {
        super(props);
        this.state = {
            ProductWrappers: null,
            isLoading: true,
            isBusy: false,
            accountRole: [],
            errorMessages: [],
            selectedClientInfo: null,
            allAccounts: [],
            urlCustomer: { ActorId: getQueryParameters()["customerid"] },
            accountDisinvestmentStrategy: null,
            companyDisinvestmentStrategy: null,
            fsaPermission: [],
        };
        this.subscribeToStore(ProductWrapperStore, () => this.onProductWrapperStoreChange());
        this.subscribeToStore(AdviserContextStoreStatic, () => this.onAdviserContextStoreChange());
        this.subscribeToStore(CustomerContextStoreStatic, () => this.onCustomerContextStoreChange());
        this.subscribeToStore(PortfolioDashboardStore, () => this.onAllAccountsChange());
    }
    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);
        const newData = this.props.data;
        const prevData = (prevProps as { data: QuoteAndApplyBaseModel }).data;
        if (
            prevData.AccountServiceProposition != newData.AccountServiceProposition &&
            newData.AccountServiceProposition
        ) {
            const actorId = getQueryParameters()["customerid"];
            NewBusinessAction.getProductWrappers(actorId, newData.AccountServiceProposition);
        }
        if (this.isCreateNewAccount() && this.hasSecondClientDetailsChanged(prevProps)) {
            this.loadRestriction();
        }
    }

    hasSecondClientDetailsChanged(prevProps) {
        return (
            (!prevProps.data?.SecondClientDetails && this.props.data?.SecondClientDetails) ||
            (prevProps.data?.SecondClientDetails && !this.props.data?.SecondClientDetails) ||
            prevProps.data?.SecondClientDetails?.ActorId != this.props.data?.SecondClientDetails?.ActorId
        );
    }
    componentDidMount() {
        super.componentDidMount();
        const hierarchyId = getQueryParameters()["hierarchyid"];
        const { data } = this.props;
        const id = getQueryParameters()["id"];
        let customerid = getQueryParameters()["customerid"];
        if (id || data.AccountServiceProposition) {
            NewBusinessAction.getProductWrappers(customerid, data.AccountServiceProposition);
        }
        //NBEC
        if (hierarchyId) {
            Action.getAccountRoles(hierarchyId, (val) => {
                this.setState({ accountRole: val });
            });
            PortfolioDashboardAction.getAllAccountsByCustomerId(Number(customerid));
            this.getStrategy(hierarchyId);
        } else {
            if (id) {
                this.getStrategyByInstructionId(id);
            }
        }

        // get url customer info
        const params = getQueryParameters();
        if (!CommonHelper.isNullOrEmpty(params["id"]) && CommonHelper.isNullOrEmpty(params["hierarychid"])) {
            customerid = this.props.data?.ClientDetails?.ActorId;
        }
        NewBusinessAction.getCustomerData(Number(customerid));
        // create new account in NBEC or NBNC
        if (this.isCreateNewAccount() && data.SecondClientDetails?.ActorId) {
            NewBusinessAction.accountHolderAction(data.SecondClientDetails?.ActorId, (result) => {
                this.setState({ selectedClientInfo: result });
            });
        }
        if (this.isCreateNewAccount()) {
            this.loadRestriction();
        }
    }

    private getStrategy(hierarchyId: string) {
        if (!CommonHelper.isNullOrEmpty(hierarchyId)) {
            ProductOverviewChargeAction.getAccountDisinvestmentStrategy(
                hierarchyId,
                (res: AccountDisinvestmentStrategy) => {
                    this.setState({ accountDisinvestmentStrategy: res.DisinvestmentStrategyType });
                    this.props.onChange({ DisinvestmentStrategy: res.DisinvestmentStrategyType });
                }
            );
        }
    }

    private getStrategyByInstructionId(instructionId: string) {
        if (!CommonHelper.isNullOrEmpty(instructionId)) {
            DisinvestmentStrategyTypeAction.getDisinvestmentStrategy(
                instructionId,
                (res: DisinvestmentStrategyTypeModel) => {
                    this.setState({ accountDisinvestmentStrategy: res.DisinvestmentStrategyType });
                    this.props.onChange({ DisinvestmentStrategy: res.DisinvestmentStrategyType });
                }
            );
        }
    }

    loadRestriction() {
        const { data } = this.props;
        const actorIds = [data?.ClientDetails?.ActorId];
        if (data.SecondClientDetails?.ActorId) {
            actorIds.push(data.SecondClientDetails?.ActorId);
        }
        RestrictionAction.getRestrictionByCustomer(actorIds);
    }
    onAllAccountsChange() {
        const data = PortfolioDashboardStore.getData();
        this.setState({ allAccounts: data });
    }
    private onProductWrapperStoreChange() {
        const data = ProductWrapperStore.getData();
        this.setState({
            isLoading: false,
            ProductWrappers: data,
        });
    }
    private onAdviserContextStoreChange() {
        const adviser = AdviserContextStoreStatic.getData();
        const id = getQueryParameters()["id"];
        if (adviser) {
            this.props.onChange({
                AdviserHierarchyId: { Type: HierarchyLevelName.Advisor, EntityId: adviser.AdvisorId },
            });
            CompanyWizardAction.getCompanyFsaPermissionDetail(adviser.Company, (result: FsaPermission[]) => {
                this.setState({ fsaPermission: result });
            });
            if (!this.state.companyDisinvestmentStrategy) {
                CompanyWizardAction.getViewCompany(adviser.Company, (res) => {
                    this.setState({
                        companyDisinvestmentStrategy: DisinvestmentStrategyTypeStringMap(res.DisinvestmentStrategy),
                    });
                    if (this.isCreateNewAccount()) {
                        if (id) {
                            this.getStrategyByInstructionId(id);
                        } else {
                            this.props.onChange({
                                DisinvestmentStrategy: DisinvestmentStrategyTypeStringMap(res.DisinvestmentStrategy),
                            });
                        }
                    }
                });
            }
        }
    }
    private isAccountRestriction() {
        const isCreateNew = this.isCreateNewAccount();
        const processType = CommonHelper.isNullOrEmpty(getQueryParameters()["claccountid"])
            ? processTypeEnum.NewBusinessExistingClient
            : processTypeEnum.NewBusiness;
        let isRestrictionActive = false;
        if (RestrictionHelper.shouldHandleRestriction(processType)) {
            isRestrictionActive = RestrictionStore.depositDisabled();
        }
        if (isCreateNew) {
            return RestrictionStore.CustomerRestrictionApplied();
        } else {
            return RestrictionStore.CustomerRestrictionApplied() || isRestrictionActive;
        }
    }
    onCustomerContextStoreChange(): void {
        const customer = CustomerContextStoreStatic.getData();
        const ClientDetails: ClientDetails = {
            ActorId: customer.ActorId,
            FirstName: customer.PersonalDetails?.GivenName,
            LastName: customer.PersonalDetails?.FamilyName,
            Title: customer.PersonalDetails?.Title,
            Gender: customer.PersonalDetails?.Gender,
            DateOfBirth: customer.PersonalDetails?.DateOfBirth,
        };
        this.props.onChange({ ClientDetails: ClientDetails });
        this.setState({ urlCustomer: ClientDetails });
    }
    render() {
        const { data, ClientAccount, onChange } = this.props;
        const { ProductWrappers } = this.state;
        const isCreateNew = this.isCreateNewAccount();
        const hasHierarchyId = !CommonHelper.isNullOrEmpty(getQueryParameters()["hierarchyid"]);

        // warning messages appear only when add new product, new client new business has no hierarchyId
        const warningMsg =
            !hasHierarchyId && data?.IsJointAccount
                ? []
                : getWarningMessage(
                      isCreateNew,
                      data?.IsJointAccount,
                      data?.SelectedProducts,
                      ClientAccount?.SubAccounts,
                      hasHierarchyId
                  );
        const isDisableCashAccount = disableCashAccount(
            isCreateNew,
            data?.IsJointAccount,
            data?.SelectedProducts,
            ClientAccount?.SubAccounts,
            !CommonHelper.isNullOrEmpty(getQueryParameters()["hierarchyid"])
        );
        const existingPensionAccount = ClientAccount?.SubAccounts?.find((x) =>
            SubAccountTypeHelper.isOnPlatformPension(x.SubAccountType)
        );

        const disableAllProductByFsa = !this.state.fsaPermission.some(
            (ele) =>
                ele?.FsaRegulatedActivity?.Name?.toLowerCase() == "AdviseInvestments".toLowerCase() &&
                ele?.IsInclude &&
                ele?.IsPermit
        );

        const isRestrictionActive = this.isAccountRestriction();
        const restrictedMessage = "An account with suspended or restricted activities cannot receive payments in";

        const options =
            ProductWrappers != null
                ? ProductWrappers.filter((w) => !SubAccountTypeHelper.isUnlistedProduct(w.Type)).map((ele) => {
                      return {
                          label: ele.DisplayName,
                          value: data.SelectedProducts.some((item) => item.SubAccountType == ele.Type),
                          onChange: (v) => {
                              let _data: SubAccountActionIndicators[] = [];
                              let isaModel = this.props.data?.IsaModel;
                              let giaModel = this.props.data?.GiaModel;
                              let pensionApply = this.props.data?.PensionApply;
                              if (v) {
                                  _data = data.SelectedProducts.concat([
                                      { SubAccountType: ele.Type, IsIncomePaymentDetailsSelected: false },
                                  ]);
                              } else {
                                  _data = data.SelectedProducts.filter((item) => item.SubAccountType !== ele.Type);
                                  if (ele.Type === SubAccountType.StocksIsa || ele.Type === SubAccountType.JuniorIsa) {
                                      isaModel = {};
                                  }
                                  if (ele.Type === SubAccountType.InvestmentAccount) {
                                      giaModel = {};
                                  }
                                  if (
                                      ele.Type === SubAccountType.Pension ||
                                      ele.Type === SubAccountType.JuniorSipp ||
                                      ele.Type === SubAccountType.Npr
                                  ) {
                                      pensionApply = {};
                                  }
                              }
                              const selectedProducts = this.adjustWrapCashSelection(
                                  _data,
                                  this.props.data?.IsJointAccount
                              );
                              const onChangeData = {
                                  IsaModel: isaModel,
                                  GiaModel: giaModel,
                                  PensionApply: pensionApply,
                                  SelectedProducts: selectedProducts,
                                  IsJointAccount: selectedProducts.length > 0 ? this.props.data?.IsJointAccount : false,
                                  AssumedHoldings:
                                      selectedProducts.some((item) =>
                                          SubAccountTypeHelper.isLegacyProduct(item.SubAccountType)
                                      ) && data?.AssumedHoldings
                                          ? data?.AssumedHoldings
                                          : ({ Amount: 0, Currency: CurrencyCode.GBP } as Money),
                              };
                              onChange(onChangeData);
                          },
                          disabled:
                              disableAllProductByFsa ||
                              !ele.IsAvailable ||
                              this.props.isReview ||
                              (!SubAccountTypeHelper.productEligibleForJoint(ele.Type) && data?.IsJointAccount) ||
                              (SubAccountTypeHelper.isOffPlatformPension(ele.Type) &&
                                  ClientAccount?.SubAccounts?.some((x) => x.SubAccountType == ele.Type)) ||
                              isRestrictionActive ||
                              (ele.Type == SubAccountType.WrapCash && isDisableCashAccount) ||
                              (ele.Type === SubAccountType.StocksIsa &&
                                  this.props.ClientAccount?.SubAccounts.some(
                                      (item) => item.SubAccountType === SubAccountType.StocksIsa
                                  )) ||
                              ele.Type == SubAccountType.WrapCash,
                      };
                  })
                : [];
        return (
            <>
                <h1>{<NewClientAlertMessage />}</h1>
                <h2 className="mb-40">{NBSteppers.wrapperSelection}</h2>
                {isRestrictionActive && <Alert alertType={AlertType.Error} message={restrictedMessage} />}
                <div className="row mb-20">
                    <div className="col-7">
                        <ServicePropositionSelection
                            actorId={getQueryParameters()["customerid"]}
                            selectedPropositionId={data.AccountServiceProposition}
                            onRef={(ref) => this.appendChild(ref)}
                            data={this.props.data}
                            onChange={(changes) => {
                                this.props.onChange(changes);
                                this.setState({ isLoading: true });
                            }}
                            isReview={this.props.isReview}
                            disable={
                                data.ExistingAccountHierarchyId != null ||
                                !CommonHelper.isNullOrEmpty(data?.ShellHeadClAccountId)
                            }
                        />
                    </div>
                </div>
                {data.AccountServiceProposition != null &&
                    data.AccountServiceProposition != ServiceProposition.NotSpecified && (
                        <PartLoading isLoading={this.state.isLoading}>
                            <>
                                <>
                                    {SectionHeader("Create new business for")}
                                    <WizardLinter status={EWizardLinterStatus.PleaseCheck}>
                                        <div className="row">
                                            <div className="col-7">
                                                <CheckboxGroup
                                                    srTitle="Create new business for"
                                                    type="panel"
                                                    options={options}
                                                />
                                            </div>
                                        </div>
                                    </WizardLinter>
                                    {warningMsg.map((msg, i) => {
                                        return (
                                            <h1 key={i}>
                                                <Alert alertType={AlertType.Warning} message={msg} />
                                            </h1>
                                        );
                                    })}
                                    <hr className="mb-20" />
                                    {data.SelectedProducts.length > 0 && (
                                        <AccountName
                                            onRef={(ref) => this.appendChild(ref)}
                                            data={data}
                                            onChange={
                                                !isCreateNew
                                                    ? () => {}
                                                    : (changes) => {
                                                          onChange(changes);
                                                      }
                                            }
                                            readOnly={
                                                !isCreateNew || !CommonHelper.isNullOrEmpty(data?.ShellHeadClAccountId)
                                            }
                                        />
                                    )}
                                    {this.selecteJointProduct(data) ? this.renderJointSingle(data, isCreateNew) : null}
                                    {isSelectedAndExisted(
                                        (x) => SubAccountTypeHelper.isOnPlatformPension(x),
                                        data?.SelectedProducts,
                                        []
                                    ).selected && (
                                        <SIPPSection
                                            onRef={(ref) => this.appendChild(ref)}
                                            data={this.props.data}
                                            HasExistingSIPP={isCreateNew ? false : this.props.HasExistingSIPP}
                                            onChange={(changes) => {
                                                this.props.onChange(changes);
                                            }}
                                            isReview={this.props.isReview}
                                            subAccountId={existingPensionAccount?.ClAccountId}
                                            subAccountHierarchyId={existingPensionAccount?.HierarchyId}
                                            isAddRegularPayment={this.isAddRegularPayment(SubAccountType.Npr)}
                                        />
                                    )}
                                    {data.SelectedProducts.some(
                                        (ele) => ele.SubAccountType == SubAccountType.StocksIsa
                                    ) && (
                                        <ISASection
                                            onRef={(ref) => this.appendChild(ref)}
                                            data={this.props.data}
                                            onChange={(changes) => {
                                                this.props.onChange(changes);
                                            }}
                                            isReview={this.props.isReview}
                                        />
                                    )}
                                    {data.SelectedProducts.some(
                                        (ele) => ele.SubAccountType == SubAccountType.InvestmentAccount
                                    ) && (
                                        <PPSection
                                            onRef={(ref) => this.appendChild(ref)}
                                            data={this.props.data}
                                            onChange={(changes) => {
                                                this.props.onChange(changes);
                                            }}
                                            isReview={this.props.isReview}
                                        />
                                    )}
                                    {data.SelectedProducts.length > 0 && (
                                        <AdviceSection
                                            data={data}
                                            onChange={(changes) => onChange(changes)}
                                            isCreateNew={isCreateNew}
                                            onRef={(ref) => this.appendChild(ref)}
                                            isReview={this.props.isReview}
                                            readonly={!isCreateNew&&!CommonHelper.isNullOrEmpty(data?.ShellHeadClAccountId)}
                                        />
                                    )}

                                    {<hr className="mb-20" />}
                                    {data.SelectedProducts.length > 0 &&
                                        data.AccountServiceProposition == ServiceProposition.Wrap &&
                                        AdviserContextStoreStatic.getData()?.Company != "SAVINGSDIRECT" && (
                                            <DisinvestmentStrategySection
                                                data={data}
                                                onChange={(changes) => onChange(changes)}
                                                onRef={(ref) => this.appendChild(ref)}
                                                isReview={this.props.isReview}
                                                readonly={!isCreateNew&&!CommonHelper.isNullOrEmpty(data?.ShellHeadClAccountId)}
                                                isCreateNew={isCreateNew}
                                            />
                                        )}
                                </>
                            </>
                        </PartLoading>
                    )}
            </>
        );
    }
    private renderJointSingle(data: ApplyModel, isCreateNew: boolean) {
        const { allAccounts } = this.state;
        return (
            <>
                <RadiosEditor
                    cssWrapper="radio-group rg-inline rg-150 mb-23"
                    label="Account type"
                    selected={data.IsJointAccount ? InvestorType.Joint : InvestorType.Single}
                    options={this.selectableInvestorTypes()}
                    getText={(v) => {
                        return PersonalPortfolioTypesMap[v];
                    }}
                    onChange={(v) => {
                        let secondClientDetails = this.props.data?.SecondClientDetails;
                        let clientDetails = this.props.data?.ClientDetails;
                        const curIsCreateNew = isCreatingNewAccount(
                            getQueryParameters()["hierarchyid"],
                            { IsJointAccount: v == InvestorType.Joint },
                            allAccounts
                        );
                        const isNewBusiness = CommonHelper.isNullOrEmpty(getQueryParameters()["hierarchyid"]);
                        if (curIsCreateNew) {
                            secondClientDetails = null;
                            clientDetails = this.state.urlCustomer;
                        } else {
                            clientDetails = this.CustomerToClientDetails(
                                this.state.accountRole.find((x) => x.IsPrimary)?.Customer
                            );
                            secondClientDetails =
                                v == InvestorType.Joint
                                    ? this.CustomerToClientDetails(
                                          this.state.accountRole.find((x) => !x.IsPrimary)?.Customer
                                      )
                                    : null;
                        }
                        this.props.data.IsJointAccount = v == InvestorType.Joint;
                        const selectedProducts = this.adjustWrapCashSelection(
                            this.props.data?.SelectedProducts,
                            v == InvestorType.Joint
                        );
                        this.props.onChange({
                            SecondClientDetails: secondClientDetails,
                            ClientDetails: clientDetails,
                            SelectedProducts: selectedProducts,
                            IsJointAccount: selectedProducts.length > 0 && v == InvestorType.Joint,
                            DisinvestmentStrategy: curIsCreateNew
                                ? this.state.companyDisinvestmentStrategy
                                : this.state.accountDisinvestmentStrategy,
                            AccountName: {
                                Full: isNewBusiness
                                    ? this.props.data?.AccountName?.Full
                                    : curIsCreateNew
                                    ? ""
                                    : this.props.ClientAccount?.AccountName,
                            },
                            ActivityType: curIsCreateNew
                                ? ProcessType.NewBusiness
                                : ProcessType.NewBusinessExistingClient,
                        });
                    }}
                    disabled={data.AccountRoleInstructionId > 0}
                    required="Please choose account type"
                />
                {data?.IsJointAccount && isCreateNew && (
                    <JointAccountHolder
                        selectedClientInfo={this.state.selectedClientInfo}
                        data={data}
                        isReview={this.props.isReview}
                        onRef={(ref) => this.appendChild(ref, 999)} // 999 is specified for joint account holder
                        onChange={(changes) => this.props.onChange(changes)}
                        onSelectClientInfoChange={(updatedModel) => this.setState({ selectedClientInfo: updatedModel })}
                    />
                )}
            </>
        );
    }
    private CustomerToClientDetails(customer: Customer): ClientDetails {
        return {
            ActorId: customer?.CustomerId,
            FirstName: customer?.PersonalDetails?.Name?.Given,
            LastName: customer?.PersonalDetails?.Name?.Family,
        };
    }
    selecteJointProduct(data: QuoteAndApplyBaseModel): boolean {
        return data.SelectedProducts.some((x) => SubAccountTypeHelper.productEligibleForJoint(x.SubAccountType));
    }
    selectableInvestorTypes(): InvestorType[] {
        const { data, ClientAccount } = this.props;
        const { allAccounts } = this.state;
        const anyProductSupportJoint = this.selecteJointProduct(data);
        const isNBEC = !CommonHelper.isNullOrEmpty(getQueryParameters()["hierarchyid"]);
        if (isNBEC) {
            //  SLP-80640.8 -- Scenario 3
            if (
                (allAccounts || []).every(
                    (account) =>
                        account.InvestorType == InvestorTypeAccount.Joint ||
                        account?.InvestorType == InvestorTypeAccount.JointIndividual
                )
            ) {
                return [InvestorType.Single, InvestorType.Joint];
                //  SLP-80640.8 -- Scenario 1
            } else if ((allAccounts || []).every((account) => account.InvestorType == InvestorTypeAccount.Individual)) {
                return [InvestorType.Single, InvestorType.Joint];
            } else {
                //  SLP-80640.8 -- Scenario 2
                return ClientAccount?.InvestorType == InvestorTypeAccount.Joint ||
                    ClientAccount?.InvestorType == InvestorTypeAccount.JointIndividual
                    ? [InvestorType.Joint]
                    : [InvestorType.Single];
            }
        } else {
            if (!anyProductSupportJoint) {
                return [InvestorType.Single];
            } else {
                return [InvestorType.Single, InvestorType.Joint];
            }
        }
    }
    private isCreateNewAccount(): boolean {
        const hierarchyId = getQueryParameters()["hierarchyid"];
        const { data } = this.props;
        const { allAccounts } = this.state;
        return isCreatingNewAccount(hierarchyId, data, allAccounts);
    }
    public isValid(): boolean {
        if (this.isAccountRestriction()) {
            return false;
        }

        const isValid = super.isValid();
        let msg: string[] = [];
        msg = msg.concat(this.checkFsa());
        msg = msg.concat(this.checkmaxGiasHit());
        msg = msg.concat(this.checkProductSelected());
        msg = msg.concat(this.checkIsaProduct());
        msg = msg.concat(this.checkWrapSelectionForJointAccount());
        msg = msg.concat(this.checkSecondClient());
        if (msg.length > 0) {
            this.props.showErrorMsgPopUp(msg);
            return false;
        }

        return isValid;
    }
    private maxGiasHit(): boolean {
        return ClientAcountHelper.MaxGiaCountHit(this.props.ClientAccount);
    }
    private checkmaxGiasHit(): string[] {
        if (this.isCreateNewAccount()) {return [];}
        const giaSelected = this.props.data.SelectedProducts.find((x) => SubAccountTypeHelper.isPP(x.SubAccountType));
        if (giaSelected && this.maxGiasHit()) {
            return [
                "This account already holds 5 Personal Portfolio sub accounts, this is the maximum number that can be opened under an Individual Account.",
            ];
        }
        return [];
    }

    private checkFsa(): string[] {
        const disableAllProductByFsa = !this.state.fsaPermission.some(
            (ele) =>
                ele?.FsaRegulatedActivity?.Name?.toLowerCase() == "AdviseInvestments".toLowerCase() &&
                ele?.IsInclude &&
                ele?.IsPermit
        );
        if (disableAllProductByFsa) {
            return ["FCA Permissions prevents the following action."];
        }
        return [];
    }

    private checkWrapSelectionForJointAccount(): string[] {
        if (
            this.props.data?.IsJointAccount &&
            this.props.data?.SelectedProducts.some(
                (x) => SubAccountTypeHelper.productEligibleForJoint(x.SubAccountType) == false
            )
        ) {
            return ["There are some products not eligible for joint account"];
        }
        return [];
    }
    private checkSecondClient(): string[] {
        if (this.props.data?.IsJointAccount && this.withValidSecondClient() == false) {
            return ["Please add a client to the joint account"];
        }
        // save second account holder persornal info into CCM
        if (this.getChild(999)) {
            this.getChild(999).Save(); /// 999 stands for joint account holder component
        }
        return [];
    }
    private withValidSecondClient() {
        return this.props.data.SecondClientDetails?.ActorId > 0;
    }
    private checkProductSelected(): string[] {
        const productSelected = this.props.data?.SelectedProducts != null && this.props.data.SelectedProducts.length > 0;
        if (!productSelected) {
            return ["At least one wrapper must be selected."];
        }
        return [];
    }
    private checkIsaProduct(): string[] {
        const isCreateNew = this.isCreateNewAccount();
        if (isCreateNew) {return [];}
        const { existed, selected } = isSelectedAndExisted(
            (x) => SubAccountTypeHelper.isIsa(x),
            this.props.data?.SelectedProducts,
            this.props.ClientAccount?.SubAccounts
        );
        if (existed && selected) {
            return [
                `The selected account already contains an existing ISA sub-account. The Account Number is ${
                    (this.props.ClientAccount?.SubAccounts || []).find((ele) =>
                        SubAccountTypeHelper.isIsa(ele.SubAccountType)
                    )?.ClAccountId
                }. Please use the Single Payment/Transfer or Regular Payments process to add a contribution to this account.`,
            ];
        }
        return [];
    }
    adjustWrapCashSelection(data: SubAccountActionIndicators[], isJointAccount): SubAccountActionIndicators[] {
        const wrapCash = data.find((x) => SubAccountTypeHelper.isWrapCash(x.SubAccountType));
        const isCreateNew = this.isCreateNewAccount();
        if (isCreateNew && (!wrapCash || !isJointAccount)) {
            // when create new bussiness which havs no Wrap Cash or Joint account type
            const checkResult = data.find((x) => x.SubAccountType === SubAccountType.WrapCash);
            return checkResult ? data : data.concat([{ SubAccountType: SubAccountType.WrapCash }]); // avoid duplicate wraps
        } else if (wrapCash && data.length == 1 && isCreateNew) {
            return [];
        }
        if (isJointAccount && !data.every((ele) => SubAccountTypeHelper.productEligibleForJoint(ele.SubAccountType))) {
            return data.filter((x) => SubAccountTypeHelper.productEligibleForJoint(x.SubAccountType));
        }
        return data;
    }
    isAddRegularPayment(subAccountType: SubAccountType): boolean {
        if (SubAccountTypeHelper.isOnPlatformPension(subAccountType)) {
            const data = ProductDetailsStore.getProductDetails()?.Products?.find((details) => {
                return (
                    details.ProductType === SubAccountType.Pension ||
                    details.ProductType === SubAccountType.Sipp ||
                    details.ProductType === SubAccountType.Npr
                );
            });
            return data?.RegularPaymentIns?.length <= 0;
        }
        return false;
    }
}
